import { Construction } from 'lucide-react'
import type { ReactNode } from 'react'

import { Card, CardContent } from '@/components/ui/card'

type ComingSoonProps = {
  title: string
  description?: string
  children?: ReactNode
}

export function ComingSoon({ title, description, children }: ComingSoonProps) {
  return (
    <Card className="border-dashed">
      <CardContent className="flex flex-col items-start gap-3 p-10">
        <div className="flex h-10 w-10 items-center justify-center rounded-md bg-muted text-muted-foreground">
          <Construction className="h-5 w-5" />
        </div>
        <div className="space-y-1">
          <p className="text-base font-medium">{title}</p>
          {description && (
            <p className="max-w-prose text-sm text-muted-foreground">{description}</p>
          )}
        </div>
        {children}
      </CardContent>
    </Card>
  )
}
